// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ald6sQZP","child":"__6sQTZZHD"};